import { SWS_IMAGES } from '@/constants';

export const getCompanyInfographicDownloadUrl = (
  companyId: string,
  section: string
) => `${SWS_IMAGES}/company/${companyId}/chart/${section}`;

export const getPortfolioInfographicDownloadUrl = (
  portfolioId: string,
  section: string,
  secretCode: string
) => {
  if (portfolioId && section && secretCode)
    return `${SWS_IMAGES}/portfolio/${portfolioId}/${section}/${secretCode}`;

  return null;
};
